import { render } from "./TwoFactorAuthentication.vue?vue&type=template&id=7f6c7e66"
import script from "./TwoFactorAuthentication.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthentication.vue?vue&type=script&lang=js"

import "./TwoFactorAuthentication.vue?vue&type=style&index=0&id=7f6c7e66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__